import { render, staticRenderFns } from "./RejectionLetter.vue?vue&type=template&id=fced7854&scoped=true&"
import script from "./RejectionLetter.vue?vue&type=script&lang=js&"
export * from "./RejectionLetter.vue?vue&type=script&lang=js&"
import style0 from "./RejectionLetter.vue?vue&type=style&index=0&id=fced7854&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fced7854",
  null
  
)

export default component.exports